// Comprehensive cart debugging utility
const CartDebug = {
  logs: [],

  log(component, action, data) {
    const timestamp = new Date().toISOString().split('T')[1].slice(0, -1);
    const logEntry = {
      timestamp,
      component,
      action,
      data: JSON.parse(JSON.stringify(data || {}))
    };
    this.logs.push(logEntry);

    console.log(`
═══════════════════════════════════════════════════════════
[${timestamp}] ${component} → ${action}
${JSON.stringify(data, null, 2)}
═══════════════════════════════════════════════════════════
    `);
  },

  error(component, action, error) {
    const timestamp = new Date().toISOString().split('T')[1].slice(0, -1);
    console.error(`
❌❌❌ ERROR ❌❌❌
[${timestamp}] ${component} → ${action}
Error: ${error.message}
Stack: ${error.stack}
═══════════════════════════════════════════════════════════
    `);
  },

  getLogs() {
    return this.logs;
  },

  clearLogs() {
    this.logs = [];
  }
};

// Make it globally accessible for debugging
if (typeof window !== 'undefined') {
  window.CartDebug = CartDebug;
}

export default CartDebug;
